import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Private from './privateRoute';
import DashboardPage from 'pages/dashboard';
import LoginPage from 'pages/authPage/loginPage';
import LogoutPage from 'pages/authPage/logoutPage';
import UsersList from 'pages/users/usersList';
import DeletedUsersList from 'pages/users/deletedUsersList';
import BackendUsers from 'pages/users/backendUsers';
import ReportedUsers from 'pages/users/reportedUsers';
import ReportedPost from 'pages/posts/reportedPosts';
import Searches from 'pages/posts/searches';
import UsersGroups from 'pages/usersGroups';
import { GroupPermissions, UserPermissions } from 'pages/permissions';
import ProfilePage from 'pages/users/profilePage';
import PostDetails from 'pages/posts/postDetails';
import ChangePassword from 'pages/authPage/changePassword'
import VerifyOtp from 'pages/authPage/verifyOtp';
import { MainLayout } from 'components/Layout';
import Page from 'components/Page';
import ForgotPassword from 'pages/authPage/forgotPassword';
import componentQueries from 'react-component-queries';
import { screenSize, screenWidth } from 'hooks';
import FailedUrls from 'pages/failedUrls';
import AdminApiDocumentation from 'pages/documentation/admin-api-documentation';
import MobileApiDocumentation from 'pages/documentation/mobile-api-documentation';
import SwissearchApiDocumentation from 'pages/documentation/swissearch-api-documentation';
//import GeographicalUsersCount from 'pages/geographical-users-count';
//mport Faq from 'pages/settings/faq';
//import About from 'pages/settings/about';
import Cms from 'pages/settings/cms';
//import Privacy from 'pages/settings/privacy';
//import Term from 'pages/settings/term';
import MapComp from '../pages/geographical-users-count/map';
import CampaignList from 'pages/campaign/campaignList';
import CampaignDetails from 'pages/campaign/campaignDetails';
//import CampaignCharges from 'pages/campaign/campaignCharges';
import Interest from 'pages/interest';
import Transactions from 'pages/transactions';
//import AdvertisingGuidelines from 'pages/settings/advertising-guidelines';
import AdminSettings from 'pages/settings/admin-settings';
import FrequentlyUsedUrls from 'pages/failedUrls/frequently.used.urls';
import WidgetSelector from 'pages/dashboard/widget.selector';
import CampaignUsers from 'pages/campaign/campaignUsers';
import CampaignCalenderSettings from 'pages/campaign/campaign-calender-settings';
import Notifications from 'pages/notifications/index';
import SignupCodes from 'pages/signupCodes/index';

const App = (props) => {

    const [campaignName, setCampaignName] = React.useState('');
    
    return (<Router>
        <Routes>
            <Route exact path="/login" element={<LoginPage {...props} />} />
            <Route exact path="/verify-otp" element={<VerifyOtp {...props} />} />
            <Route exact path="/forgot-password" element={<ForgotPassword {...props} />} />
            <Route exact path="/logout" element={<LogoutPage />} />


            <Route exact path="/deleted-users" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Deleted Users"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Deleted Users', active: true }]} >
                            <DeletedUsersList />
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/campaign-calender-settings" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Campaign Settings"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Campaign Settings', active: true }]} >
                            <CampaignCalenderSettings />
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/campaign-list" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Campaign"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Campaign', active: true }]} >
                            <CampaignUsers deleted={0}/>
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/deleted-campaigns" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Deleted Campaign"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Deleted Campaign', active: true }]} >
                            <CampaignUsers deleted={1}/>
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/dashboard-widgets/ADS" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Dashboard Widgets"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Campaign Dashboard Widgets', active: true }]} >
                            <WidgetSelector type={'ADS'}/>
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/dashboard-widgets/POST" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Dashboard Widgets"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Dashboard Widgets', active: true }]} >
                            <WidgetSelector type={'POST'}/>
                        </Page>
                    </MainLayout>
                </Private>
            } />



            <Route exact path="/transactions" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Transaction History"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Transaction History', active: true }]} >
                            <Transactions />
                        </Page>
                    </MainLayout>
                </Private>
            } />





<Route exact path="/signup-codes" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Signup Codes"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Signup Codes', active: true }]} >
                            <SignupCodes />
                        </Page>
                    </MainLayout>
                </Private>
            } />


            <Route exact path="/interest" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Interest"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Interest', active: true }]} >
                            <Interest />
                        </Page>
                    </MainLayout>
                </Private>
            } />


            {/*<Route exact path="/campaign-charges" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Campaign Charges"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Campaign Charges', active: true }]} >
                            <CampaignCharges />
                        </Page>
                    </MainLayout>
                </Private>
            } />*/}

            <Route exact path="/campaign-details/:campaignId" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Campaign Details"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: campaignName, active: true }]} >
                            <CampaignDetails getCampaignName={(name) => setCampaignName(name)} />
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/campaign-list1" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Campaign List"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Campaign List', active: true }]} >
                            <CampaignList />
                        </Page>
                    </MainLayout>
                </Private>
            } />



            <Route exact path="/settings" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Settings"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Settings', active: true }]} >
                            <AdminSettings />
                        </Page>
                    </MainLayout>
                </Private>
            } />



            <Route exact path="/faq" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="CMS PAGES"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'FAQ', active: true }]} >
                            <Cms name="faq"/>
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/advertising-guidelines" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="CMS PAGES"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Advertising Guidelines', active: true }]} >
                            
                            <Cms name="advertising_guidelines"/>
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/understanding-your-insight" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="CMS PAGES"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Understanding Your Insight', active: true }]} >
                            <Cms name="understanding_your_insight"/>
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/payment_terms" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="CMS PAGES"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Payment Terms', active: true }]} >
                            <Cms name="payment_terms"/>
                        </Page>
                    </MainLayout>
                </Private>
            } />



            <Route exact path="/about" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="CMS PAGES"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'About Us', active: true }]} >
                            <Cms name="about"/>
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/child-safety-policy" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="CMS PAGES"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Child Safety Policy', active: true }]} >
                            <Cms name="child_safety_policy"/>
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/privacy" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="CMS PAGES"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Privacy', active: true }]} >
                            <Cms name="privacy"/>
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/term" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="CMS PAGES"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Term and Conditions', active: true }]} >
                            <Cms name="term"/>
                        </Page>
                    </MainLayout>
                </Private>
            } />







            <Route exact path="/geographical-users-count" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Users Geographic Data"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Users Geographic Data', active: true }]} >
                            <MapComp />
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/mobile-api-documentation" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Apis"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Mobile App Apis', active: true }]} >
                            <MobileApiDocumentation />
                        </Page>
                    </MainLayout>
                </Private>
            } />





            <Route exact path="/swissearch-api-documentation" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Swissearch Api"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Swissearch Apis', active: true }]} >
                            <SwissearchApiDocumentation />
                        </Page>
                    </MainLayout>
                </Private>
            } />


            <Route exact path="/api-documentation" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Apis"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Admin Apis', active: true }]} >
                            <AdminApiDocumentation />
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Dashboard"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Dashboard', active: true }]} >
                            <DashboardPage />
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/users-groups" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Users Groups"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Users Groups', active: true }]} >
                            <UsersGroups />
                        </Page>
                    </MainLayout>
                </Private>
            } />


            <Route exact path="/change-password" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Change Password"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Change Password', active: true }]} >
                            <ChangePassword />
                        </Page>
                    </MainLayout>
                </Private>
            } />



            <Route exact path="/failed-urls" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Failed Urls"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Failed Urls', active: true }]} >
                            <FailedUrls />
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/frequently-used-urls" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Frequently used Urls"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Frequently used Urls', active: true }]} >
                            <FrequentlyUsedUrls />
                        </Page>
                    </MainLayout>
                </Private>
            } />






            <Route exact path="/manage-group-permissions" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Manage Permissions"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Manage Permissions', active: true }]} >
                            <GroupPermissions />
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/manage-user-permissions/:userId" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Backend Users"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Manage User Permissions', active: true }]} >
                            <UserPermissions />
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/backend-users" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Backend Users"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Backend Users', active: true }]} >
                            <BackendUsers />
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/users" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Users List"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Users List', active: true }]} >
                            <UsersList />
                        </Page></MainLayout>
                </Private>
            } />
            <Route exact path="/reported-users" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Report Users"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Report Users', active: true }]} >
                            <ReportedUsers />
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/reported-posts" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Report Posts"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Report Posts', active: true }]} >
                            <ReportedPost />
                        </Page>
                    </MainLayout>
                </Private>
            } />
            <Route exact path="/post-details/:postId" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Post Details"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Post Details', active: true }]} >
                            <PostDetails />
                        </Page>
                    </MainLayout>
                </Private>
            } />

            <Route exact path="/searches" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            title="Searches"
                            breakpoint={props.breakpoint}
                            breadcrumbs={[{ name: 'Searches', active: true }]} >
                            <Searches />
                        </Page>
                    </MainLayout>
                </Private>} />
            <Route exact path="/user-profile/:userId" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            breakpoint={props.breakpoint}
                            title="User Profile"
                            breadcrumbs={[{ name: 'Users List', active: false }, { name: 'User Profile', active: true }]} >
                            <ProfilePage breakpoint={props.breakpoint} />
                        </Page>
                    </MainLayout>
                </Private>} />

            <Route exact path="/notifications" element={
                <Private>
                    <MainLayout Swidth={props.width} breakpoint={props.breakpoint}>
                        <Page
                            breakpoint={props.breakpoint}
                            title="Notifications"
                            breadcrumbs={[{ name: 'Notifications', active: false }, { name: 'Notifications', active: true }]} >
                            <Notifications breakpoint={props.breakpoint} />
                        </Page>
                    </MainLayout>
                </Private>} />




        </Routes>
    </Router >)
};

export default componentQueries(screenSize, screenWidth)(App);

